import type { DropdownFilterItemContent } from '@carboncopyco/ui';
import { useState } from 'react';

export const useMultiDropdownFilter = ({
  fixedGroupItems,
  selectedItems,
}: {
  fixedGroupItems: DropdownFilterItemContent<string>[];
  selectedItems?: Record<string, boolean>;
}) => {
  const [selectedItemsLocal, setSelectedItems] = useState<
    Record<string, boolean>
  >({});

  const selectedItemsState = selectedItems ?? selectedItemsLocal;

  return {
    selectedItems: Object.fromEntries(
      fixedGroupItems
        .filter((item) => selectedItemsState[item.id])
        .map((item) => [item.id, item.label])
    ) as Record<string, string>,
    onChange: (item: string) => {
      if (!selectedItems) {
        setSelectedItems({
          ...selectedItemsLocal,
          [item]: !selectedItemsLocal[item],
        });
      }
    },
    onClear: () => {
      if (!selectedItems) {
        setSelectedItems({});
      }
    },
  };
};
